import router from "@/router";
import store from "@/vuex";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import getPageTitle from "@/utils/get-page-title";
// import getPageAuth from "@/utils/get-page-auth";
import getPageOj from "@/utils/get-page-oj";
import { testSchoolQustionBankAuth } from "@/api/educational.js";
import { api_schFreshAuthData } from "@/api/userApi";

import { Message } from "element-ui";

import { setNavChildren } from "@/utils/utils";

//路由白名单列表，把路由添加到这个数组，不用登陆也可以访问
const whiteList = [
  "/login",
  "/",
  "/m_index",
  "/s-link",
  "/homeSchoolConnection",
  "/MiniWorksDetails",
  "/MyMatchRanking",
  "/shareRanking",
  "/learningReport"
];
const adminWhiteList = ["/background/login"];

//定义一个可以调用的函数
function checkVersion() {
  try {
    // 开发模式下，不做此项判断。有热更新一直在刷新
    if (process.env.NODE_ENV === "production") {
      // 版本监控
      fetch(`/version.json?v=${Date.now()}`)
        .then((res) => {
          if (res.status === 200) {
            return res.json();
          } else {
            return null;
          }
        })
        .then((data) => {
          console.log("时间戳Data");
          console.log(data);
          console.log("VUE_APP_VERSION");
          console.log(process.env.VUE_APP_VERSION);

          if (data && process.env.VUE_APP_VERSION != data.version) {
            window.location.reload();
          }
        });
    }
  } catch (err) {
    console.log(err);
  }
}
function getPagePermision(list, resultName, type) {
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    if (type === "only") {
      if (
        item.alias.split(",").includes(resultName) &&
        item.children.length > 0
      ) {
        return item;
      }
    }
    if (type === "all") {
      if (item.alias.split(",").includes(resultName)) {
        return item;
      }
    }
    const childResult = getPagePermision(item.children, resultName, type);
    if (childResult) {
      return childResult;
    }
  }
  return null;
}

//主要负责全局路由守卫和登录判断
router.beforeEach(async (to, from, next) => {
  NProgress.start();

  console.log("路径");
  console.log(to);

  if (to.path.indexOf("background") !== -1) {
    if (store.getters.adminToken) {
      if (to.path === "/background/login") {
        next({
          path: "/background",
        });
        NProgress.done();
      } else {
        next();
      }
    } else {
      if (adminWhiteList.indexOf(to.path) !== -1) {
        // 在免登录白名单，直接进入
        next();
      } else {
        store.dispatch("AdminLogOut").then(() => {
          next({
            path: `/background/login?redirect=${to.name}`,
          });
        });
        NProgress.done();
      }
    }
  } else {
    // 设置标题
    document.title = getPageTitle(store.state.user.schoolInfo.name);
    if (store.getters.token) {
      if (to.path === "/login") {
        next({
          path: "/",
        });
        NProgress.done();
      } else {
        if (to.path.startsWith("/school-home-page")) {
          // console.log("--------去学校管理页面-----------");
          await api_schFreshAuthData().then((res) => {
            if (res.flag && res.message) {
              let authTree = window.JSON.parse(res.message);
              if (authTree) {
                authTree = setNavChildren(authTree.children, true);
              }
              store.commit("SET_PERMISION", authTree || "");
            }
          });
          // getPageAuth(to.name, function (res) {
          //   console.log("页面权限");
          //   if (res.data.success) {
          //     next();
          //   } else {
          //     console.log("无此页面权限");
          //     router.push({
          //       path: "/",
          //     });
          //     Message.warning("无权限访问");
          //     NProgress.done();
          //   }
          // });
          // 用户切换角色后，在校区管理页面，如果没有当前对应的栏目，跳转到第一个有效路径
          // const leave = to.path.split('/').length - 1;
          // if (leave > 2 || store.getters.permisionList.join('') === '') {
          //   next();
          // } else {
          // console.log('store.getters.permisionList:', store.getters.permisionList)
          // const permisionFirst = getPagePermision(
          //   store.getters.permisionList,
          //   to.name,
          //   'only'
          // )
          const permisionLast = getPagePermision(
            store.getters.permisionList,
            to.name,
            "all"
          );
          // console.log('permisionFirst:', permisionFirst)
          // console.log('permisionLast:', permisionLast)
          const findRs = permisionLast;
          if (!findRs) {
            console.log(store.getters.permisionList);
            next({
              name: store.getters.permisionList[0].children[0].alias.split(
                ","
              )[0],
            });
          } else {
            next();
          }
        } else if (
          to.path.startsWith("/community/home") ||
          to.path.startsWith("/community/explore") ||
          to.path.startsWith("/community/shared")
        ) {
          //社区权限
          console.log(123456, 123456);
          console.log(store.state, 123456);
          if (store.state.user.identity === 2) {
            if (store.state.user.userInfo.zoneAuth === true) {
              next();
            } else {
              router.push({
                path: "/",
              });
              Message.warning("无权限访问");
              NProgress.done();
            }
          } else {
            next();
          }
        } else if (to.path.startsWith("/oj")) {
          //OJ
          // console.log("--------去OJ页面-----------");
          getPageOj(to.name, function (res) {
            console.log("页面权限");
            console.log(res.data.content, 22254);
            if (res.data.content && res.data.content.is_have_auth === true) {
              next();
            } else {
              console.log("无此页面权限");
              router.push({
                path: "/",
              });
              Message.warning("无权限访问");
              NProgress.done();
            }
          });
        } else if (to.path.startsWith("/exam")) {
          //题库
          // console.log("--------去题库页面-----------");
          testSchoolQustionBankAuth({ permission_key: to.name }).then(res => {
            // console.log("页面权限");
            if (res.is_have_auth === true) {
              next();
            } else {
              console.log("无此页面权限");
              router.push({
                path: "/",
              });
              Message.warning("无权限访问");
              NProgress.done();
            }
          });
        } else {
          //console.log("---------去普通页面-----------");
          next();
        }
      }
    } else {
      if (whiteList.indexOf(to.path) !== -1) {
        // 在免登录白名单，直接进入
        next();
      } else {
        store.dispatch("LogOut").then(() => {
          next({
            path: `/login?redirect=${to.name}`,
          });
        });
        NProgress.done();
      }
    }
  }

  //检测版本号
  checkVersion();
});

router.afterEach(() => {
  window.scrollTo(0, 0);
  NProgress.done();
});
